import React, { createContext, useState, useEffect, ReactNode } from 'react';

import { noop } from 'lodash';

import { useRoutes } from '@/common/hooks';

export type PagePanelContextType = {
	isPanelOpen: boolean;
	openPanel: (content: ReactNode) => void;
	closePanel: () => void;
	panelContent: ReactNode | null;
};

const defaultContextValue: PagePanelContextType = {
	isPanelOpen: false,
	openPanel: noop,
	closePanel: noop,
	panelContent: null,
};

export const PagePanelContext = createContext<PagePanelContextType>(defaultContextValue);

export const PagePanelContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const { fullPathname } = useRoutes();
	const [isPanelOpen, setPanelOpen] = useState(true);
	const [panelContent, setPanelContent] = useState<React.ReactNode | null>(null);

	useEffect(() => {
		setPanelOpen(false);
	}, [fullPathname]);

	const openPanel = (content: ReactNode) => {
		setPanelContent(content);
		setPanelOpen(true);
	};

	const closePanel = () => {
		setPanelOpen(false);
	};

	return (
		<PagePanelContext.Provider value={{ isPanelOpen, openPanel, closePanel, panelContent }}>
			{children}
		</PagePanelContext.Provider>
	);
};
